import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../loader-overlay/loader-overlay.component';

import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import DialogServices from '../../services/dialog.service';
import GoogleRestServices from '../../services/google-rest.service';
import Session from '../../utils/session.service';

@Component({
    standalone: true,
    selector: 'modal-calendar-selection',
    templateUrl: './modal-calendar-selection.component.html',
    imports: [
        MatCheckboxModule,
        CommonModule,
        FormsModule,
        MatSelectModule,
        TranslatePipe,
        LoaderOverlayComponent
    ]
})
export class ModalCalendarSelectionComponent implements OnInit {
    private readonly dialogRef = inject(MatDialogRef<ModalCalendarSelectionComponent>);
    private readonly dialogServices = inject(DialogServices);

    private readonly data = inject(MAT_DIALOG_DATA);

    private readonly session = inject(Session);
    private readonly googleRestServices = inject(GoogleRestServices);
    private readonly angularFilterHelperService = inject(AngularFilterHelperService);

    vm: any = undefined;

    constructor() {
        this.vm = this;
    }

    ngOnInit() {
        this.vm.processing = false;
        this.vm.isSyncInProgress = false;
        this.vm.isTokenCorrupted= false;
        this.vm.initialized = true;

        this.vm.disableIntegration = this.disableIntegration;
        this.vm.synchronizeNow = this.synchronizeNow;
        this.vm.saveChanges = this.saveChanges;
        this.vm.close = this.close;

        this.fetchGoogleCalendars();

        this.vm.isTokenExpired = false;
        this.vm.selectedCalendar = null;
        this.vm.modifiedSelectedCalendar = null;
        this.vm.calendars = [];
        this.vm.nonSelectedCalendars = [];
    }

    private fetchGoogleCalendars() {
        this.vm.processing = true;
        this.googleRestServices.getUserCalendars(
            (response: any) => {
                console.log(response);
                this.vm.calendars = response;
                this.vm.isTokenCorrupted = response.length === 0;
                this.vm.selectedCalendar = response.find(calendar => calendar.selected);
                this.vm.modifiedSelectedCalendar = response.find(calendar => calendar.selected);
                this.recalculateExclusions();
                this.vm.processing = false;
            },
            (error) => {
                console.error(error);
                this.vm.processing = false;
            }
        );
    }

    private recalculateExclusions(): void {
        this.vm.nonSelectedCalendars = this.vm.calendars
            .filter(calendar => calendar.id !== this.vm?.modifiedSelectedCalendar?.id);
    }

    onCalendarChanged(event: MatSelectChange) {
        this.recalculateExclusions();
    }

    disableIntegration() {
        this.vm.processing = true;
        this.googleRestServices.disableIntegration(
            () => {
                this.vm.processing = false;
                this.dialogRef.close('refresh');
            },
            (error) => {
                console.error(error);
                this.vm.processing = false;
            }
        );
    }

    synchronizeNow() {
        this.vm.processing = true;
        this.vm.isSyncInProgress = true
        this.googleRestServices.syncGoogleCalendar(
        	(success) => {
        		console.log('Success syncing with Google Calendar:', success);
                this.vm.isSyncInProgress = false;
                this.vm.processing = false;
                this.dialogRef.close('refresh');
        	},
        	(error) => {
        		console.error('Error syncing with Google Calendar:', error);
                this.vm.isSyncInProgress = false
                this.vm.processing = false;
        	}
        );
    }

    saveChanges() {
        this.vm.processing = true;

        const selectedCalendarId = this.vm.modifiedSelectedCalendar?.id;
        const excludedCalendarIds= this.vm.nonSelectedCalendars
            .filter((calendar) => calendar.excluded)
            .map((calendar) => calendar.id);

        this.googleRestServices.saveUserCalendar(
            selectedCalendarId,
            excludedCalendarIds,
            () => {
                this.vm.processing = false;
                this.synchronizeNow();
            },
            (error) => {
                console.error(error);
                this.vm.processing = false;
            }
        );
    }

    close() {
        this.dialogRef.close();
    }
}
